import { useRecoilValue } from 'recoil'

import CardWithSegmentControl from '../../../components/CardWithSegmentControl'
import HorizontalBarChart from '../../../components/HorizontalBarChart'
import useCheckInEventForm from '../../../hooks/useCheckInEventForm'
import { SegmentControlAtom, ServiceAtom } from '../../../recoil/atoms'
import useGetStampUserCountDistribution from '../hooks/useGetStampUserCountDistribution'

function StampUserDistribution({ className }: { className?: string }) {
  const { form } = useCheckInEventForm()
  const service = useRecoilValue(ServiceAtom)
  const segmentOpt = useRecoilValue(SegmentControlAtom('stampUserCountDistribution'))

  const { stampUserCountDistribution, stampUserCountDistributionLoading } = useGetStampUserCountDistribution({
    serviceId: service.value,
    campaignId: form.campaignId,
    round: segmentOpt,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  return (
    <CardWithSegmentControl
      className={`${className} relative`}
      title='保有スタンプ数別 ユーザー数'
      segmentTitle='stampUserCountDistribution'
      visible={stampUserCountDistributionLoading}
      segments={[
        { label: '1R', value: '1' },
        { label: '2R', value: '2' },
        { label: '3R', value: '3' },
        { label: '4R', value: '4' },
        { label: '5R', value: '5' },
      ]}
    >
      <HorizontalBarChart
        labels={['1個', '2個', '3個', '4個', '5個', '6個', '7個', '8個', '9個', '10個'].toReversed()}
        datas={stampUserCountDistribution?.userHoldingStampCountDatas.toReversed() ?? []}
        callbackLabel={(tooltipItem) => `${tooltipItem.formattedValue}人`}
      />
    </CardWithSegmentControl>
  )
}

StampUserDistribution.defaultProps = {
  className: '',
}

export default StampUserDistribution
